import React from 'react'
import { Link } from 'react-router-dom'

function Aboutpro() {
  return (
    <div>
            
        {/* <!-- About Section Start --> */}
        <section class="about-section fix section-bg section-padding pt-0">
            <div class="right-shape">
                <img src="assets/img/home-1/about/right-shape.png" alt="img"/>
            </div>
            <div class="container">
                <div class="about-wrapper">
                    <div class="row g-4 align-items-center">
                        <div class="col-lg-6 wow fadeInUp" data-wow-delay=".3s">
                            <div class="about-image" >
                                <img src="/img/new2.jpeg" alt="img" />
                                {/* <div class="about-image-2">
                                    <img src="/img/prop.png" alt="img"/>
                                </div> */}
                                <div class="counter-box">
                                    {/* <h2><span class="count">697</span>k+</h2>
                                    <p>LISTED PROPERTIES</p> */}
                                </div>
                                {/* <span class="bar-shape"></span> */}
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="about-content">
                                <div class="section-title mb-0">
                                    <h5 class="wow fadeInUp"><i class="flaticon-home"></i> WHO WE ARE</h5>
                                    <h2 class="wow fadeInUp" data-wow-delay=".3s">
                                      🌟 Land of Dreams and Desires
                                    </h2>
                                      <h6 class="wow fadeInUp" data-wow-delay=".3s">
                                      🌟 Land of Dreams and Desires
                                    </h6>
                                </div>
                                <p class="about-text wow fadeInUp" data-wow-delay=".5s">
                                   With years of expertise, an eye for detail, and a commitment to excellence, JRB Groups has redefined real estate by blending comfort, luxury, and affordability under one roof.
                                </p>
                                <ul class="wow fadeInUp" data-wow-delay=".7s">
                                    <li>
                                        <i class="flaticon-right-arrow"></i> Decades of trusted experience
                                    </li>
                                    <li>
                                        <i class="flaticon-right-arrow"></i> Strong legacy in real estate
                                    </li>
                                    <li>
                                        <i class="flaticon-right-arrow"></i> Seamless buying & after-sales service
                                    </li>
                                     <li>
                                        <i class="flaticon-right-arrow"></i> Customer-first approach
                                    </li>
                                </ul>
                                <div class="about-btn wow fadeInUp" data-wow-delay=".3s">
                                    <Link to="/about" class="theme-btn">
                                        ABOUT US MORE <i class="flaticon-home"></i> 
                                    </Link>
                                    <div class="call-info">
                                        <div class="icon">
                                            <i class="fa-solid fa-phone-xmark"></i>
                                        </div>
                                        <div class="content">
                                            <span>Call Us 24/7</span>
                                            <h4><a href="tel:+919828551389">+91 9799418563</a></h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
  )
}

export default Aboutpro